import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";





const NotFound: React.FC = () => {

    const navigate = useNavigate();

    useEffect(() => {
        const timeout = setTimeout(() => {
            navigate("/landing", { replace: true });
        }, 4000);
        return () => clearTimeout(timeout);
    }, [navigate]);

    return (
        <div className="flex flex-col min-h-screen bg-[#F7F7FF]">
            <Header />
            <main className="flex-grow flex items-center justify-center px-4 text-center px-4">
                <div>
                    <h1 className="text-xl text-red-600 font-bold mb-2">
                        Oops! Page Not Found
                    </h1>
                    <p className="text-gray-600 ">
                    Sorry, we couldn’t find the page you’re looking for.
                    </p>
                    <p className="text-gray-600 font-semibold mt-4">
                        Redirecting you to the landing page...
                    </p>

                </div>
            </main>
            <Footer />

        </div>

    );

};

export default NotFound;